import { BallPointPen } from "../../models/ballpoint_pen/ballpoint_pen";
import { BallPointPenJsEnv } from "../../models/ballpoint_pen/ballpoint_pen_js_env";
import { BallPointPenRepository } from "../../repositories/ballpoint_pen/ballpoint_pen_repository";
import { TypedEvent } from "../../typed_event";
import { BallPointPenContainer } from "../../views/pc/ballpoint_pen/ballpoint_pen_container";

const PARAMS = new URLSearchParams(window.location.search);
const PARAM_REFINECD_1 = PARAMS.get('refineCD1');
const PARAM_REFINECD_2 = PARAMS.get('refineCD2');
const PARAM_REFINECD_3 = PARAMS.get('refineCD3');

export class BallPointPenAction {
  static readonly UPDATE_EVENT = new TypedEvent<BallPointPenJsEnv>();
  private static state: BallPointPen;
  private static ballPointPenRepository: BallPointPenRepository;
  static async init() {
    this.ballPointPenRepository = new BallPointPenRepository();
    const ballPointPenMakers = await this.ballPointPenRepository.getBallPointPenMakers();
    this.state = new BallPointPen(new BallPointPenJsEnv(ballPointPenMakers, [], [], '', '', ''));
    new BallPointPenContainer(this.state.getModel()); // NOSONAR

    if (PARAM_REFINECD_1 !== null && PARAM_REFINECD_1 !== '' && PARAM_REFINECD_2 !== null && PARAM_REFINECD_2 !== '') {
      const ballPointPenSeries = await this.ballPointPenRepository.getBallPointPenSeries(PARAM_REFINECD_1);
      const ballPointPenSizes = await this.ballPointPenRepository.getBallPointPenSizes(PARAM_REFINECD_1, PARAM_REFINECD_2);
      this.state.updateModel(ballPointPenSeries, ballPointPenSizes, PARAM_REFINECD_1, PARAM_REFINECD_2, String(PARAM_REFINECD_3));
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }

    // 画面初期化のみ実行する、他画面から遷移する場合は実行しない（ボールペン替え芯検索後、キーワード検索結果画面から戻すなど）
    if (PARAM_REFINECD_1 === null || PARAM_REFINECD_1 === '') {
      // 画面タイトル（カテゴリ名で設定される）を取得する
      const categoryName = this.getCategoryName();
      // 初期化のとき、カテゴリ名はメーカー名と前方一致する場合、そのメーカー名を選択されたメーカー名とする
      const ballpointPenMaker = categoryName
        ? this.state
            .getModel()
            .ballpointPenMakers.find((element) => categoryName.startsWith(element))
        : undefined;
      if (ballpointPenMaker) {
        this.state.setSelectedBallpointPenMaker(ballpointPenMaker);
        // 初期化のとき、メーカー名が設定される場合、シリーズ名を取得する
        this.drillDownSeries(this.state.getModel().selectedMaker);
      }
    }
  }

  static async drillDownSeries(selectedMaker: string) {
    if (selectedMaker === '') {
      this.state.updateSeries([], selectedMaker);
    } else {
      const ballPointPenSeries = await this.ballPointPenRepository.getBallPointPenSeries(selectedMaker);
      this.state.updateSeries(ballPointPenSeries, selectedMaker);
    }
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static async drillDownSizes(selectedMaker: string, selectedSeries: string) {
    if (selectedSeries === '') {
      this.state.updateSizes([], selectedSeries);
    } else {
      const ballPointPenSizes = await this.ballPointPenRepository.getBallPointPenSizes(selectedMaker, selectedSeries);
      this.state.updateSizes(ballPointPenSizes, selectedSeries);
    }
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static async updateSelectedSize(selectedSize: string) {
    this.state.updateSelectedSize(selectedSize);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static getCategoryName(): string {
    // 画面タイトル（カテゴリ名で設定される）を取得する
    const categoryNameByClassName = document.getElementsByClassName('a-heading -typeh1');
    let categoryName = '';
    if (
      categoryNameByClassName === undefined ||
      categoryNameByClassName === null ||
      categoryNameByClassName.length === 0
    ) {
      return categoryName;
    }
    const categoryNameByClassNameArray = Array.from(categoryNameByClassName);
    const categoryNameByFind = categoryNameByClassNameArray.find(
      (element) =>
        element.children !== undefined &&
        element.children !== null &&
        element.children.length > 0 &&
        element.children[0].localName === 'h1'
    );
    if (categoryNameByFind) {
      categoryName = (categoryNameByFind as HTMLInputElement).innerText;
    }
    return categoryName;
  }
}
